module.exports = __webpack_public_path__ + "img/Eventos_eliminar varios.46df40ea.svg";